export default __webpack_public_path__ + "static/media/3.78c91e70.svg";